// extracted by mini-css-extract-plugin
module.exports = {"inlineFlexCenter":"HistoricViewToggleButton_inlineFlexCenter__aKmWb","pillContainer":"HistoricViewToggleButton_pillContainer__PrN_0"};